// extracted by mini-css-extract-plugin
module.exports = {"overviewcontainer":"overview_overviewcontainer__Cy0P1","overviewcontent":"overview_overviewcontent__Bfbp1","imageWrapper":"overview_imageWrapper__wIdXE"};